import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1c4820d2")
const _hoisted_1 = { class: "list_body" }
const _hoisted_2 = { style: {"margin-bottom":"10px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"2px"} }, "学校名称", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"2px"} }, "所属区域", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"2px"} }, "贡献课件数", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"2px"} }, "累计下载次数", -1)
const _hoisted_7 = { style: {"text-align":"center"} }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { style: {"color":"#1e90fa"} }
_popScopeId()

import { ref, onMounted } from 'vue'
import { getTopSchoolList } from '@/services/data-overview'
import EllipsisText from '@/components/common/EllipsisText.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tableData = ref<any[]>()

const handleGetData = async () => {
  try {
    const list = await getTopSchoolList()
    tableData.value = list.map((item, index) => ({
      ...item,
      index: index + 1
    }))
  } catch (err) {
    console.log(err)
  }
}

const getListItemStyle = (item) => {
  if (item.index === 0) {
    return {}
  }
  if (item.index < 4) {
    return {
      backgroundColor: '#fff6e5'
    }
  } else {
    return {
      backgroundColor: '#effaff'
    }
  }
}

onMounted(() => {
  handleGetData()
})


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_image = _resolveComponent("a-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, {
        style: {"width":"100%"},
        align: "middle",
        gutter: [16, 16],
        justify: "space-around"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { offset: 2 }),
          _createVNode(_component_a_col, { span: 5 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: 5 }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: 5 }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: 5 }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        style: _normalizeStyle(getListItemStyle(item)),
        class: "list_item_body",
        key: item.index
      }, [
        _createVNode(_component_a_row, {
          style: {"width":"100%"},
          align: "middle",
          gutter: [16, 16],
          justify: "space-around"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 2 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (item.index < 4 && item.index > 0)
                    ? (_openBlock(), _createBlock(_component_a_image, {
                        key: 0,
                        preview: false,
                        width: "60px",
                        src: require(`@/assets/data-overview/top${item.index}.png`)
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("h2", _hoisted_9, _toDisplayString(item.index), 1)
                      ]))
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_col, { span: 5 }, {
              default: _withCtx(() => [
                _createVNode(EllipsisText, {
                  style: { fontSize: '18px', fontWeight: 'bold' },
                  text: item.author_school_name
                }, null, 8, ["text"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_col, { span: 5 }, {
              default: _withCtx(() => [
                _createVNode(EllipsisText, {
                  style: { fontSize: '18px', fontWeight: 'bold' },
                  text: item?.ins_name || '--'
                }, null, 8, ["text"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_col, { span: 5 }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  style: _normalizeStyle([item.index < 4 ? { color: '#fc9a38' } : { color: '#1e90fa' }, {"font-size":"18px","font-weight":"bold","padding-left":"20px"}])
                }, _toDisplayString(item.count), 5)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_col, { span: 5 }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  style: _normalizeStyle([item.index < 4 ? { color: '#fc9a38' } : { color: '#1e90fa' }, {"font-size":"18px","font-weight":"bold","padding-left":"20px"}])
                }, _toDisplayString(item.total_download_num), 5)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ], 4))
    }), 128))
  ]))
}
}

})